"use strict";
var DESCRIPTORS = require("../internals/descriptors");
var UNSUPPORTED_DOT_ALL = require("../internals/regexp-unsupported-dot-all");
var classof = require("../internals/classof-raw");
var defineBuiltInAccessor = require("../internals/define-built-in-accessor");
var getInternalState = require("../internals/internal-state").get;
var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, "dotAll", {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return;
      if (classof(this) === "RegExp") {
        return !!getInternalState(this).dotAll;
      }
      throw new $TypeError("Incompatible receiver, RegExp required");
    }
  });
}
